import React, { useState } from "react";
import DSBox from "../../views/system-design/DSBox";
import DSChip from "../../views/system-design/DSChip";
import DSTextField from "../../views/system-design/DSTextField";
import DSIconButton from "../../views/system-design/DSIconButton";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

type EditableStringArrayProps = {
  label: string;
  values: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
  helperText?: string;
  disabled?: boolean;
};

const StringChipEditor = ({
  label,
  values,
  onChange,
  placeholder = "Enter value",
  helperText,
  disabled = false,
}: EditableStringArrayProps) => {
  const [inputValue, setInputValue] = useState("");

  const handleAdd = () => {
    const trimmedValue = inputValue.trim();
    if (trimmedValue && !values.includes(trimmedValue)) {
      onChange([...values, trimmedValue]);
      setInputValue("");
    }
  };

  const handleRemove = (valueToRemove: string) => {
    onChange(values.filter((value) => value !== valueToRemove));
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAdd();
    }
  };

  return (
    <DSBox>
      <DSBox sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <DSTextField
          fullWidth
          label={label}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          helperText={helperText}
          disabled={disabled}
        />
        <DSIconButton
          onClick={handleAdd}
          disabled={
            disabled || !inputValue.trim() || values.includes(inputValue.trim())
          }
          color="primary"
        >
          <AddIcon />
        </DSIconButton>
      </DSBox>
      <DSBox sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        {values.map((value, index) => (
          <DSChip
            key={index}
            label={value}
            onDelete={disabled ? undefined : () => handleRemove(value)}
            deleteIcon={<DeleteIcon />}
            variant="outlined"
          />
        ))}
      </DSBox>
    </DSBox>
  );
};

export default StringChipEditor;
